/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementDTO,
  AgreementDTOOptional,
  AgreementDTOMetaI,
  AgreementDTOTrackedI,
} from "./agreement-dto";
import { AgreementDTOTracked, AgreementDTOMeta } from "./agreement-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogCategoryDTO,
  CatalogCategoryDTOOptional,
  CatalogCategoryDTOMetaI,
  CatalogCategoryDTOTrackedI,
} from "./catalog-category-dto";
import {
  CatalogCategoryDTOTracked,
  CatalogCategoryDTOMeta,
} from "./catalog-category-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogDiscountDTO,
  CatalogDiscountDTOOptional,
  CatalogDiscountDTOMetaI,
  CatalogDiscountDTOTrackedI,
} from "./catalog-discount-dto";
import {
  CatalogDiscountDTOTracked,
  CatalogDiscountDTOMeta,
} from "./catalog-discount-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogInternalFull,
  CatalogInternalFullOptional,
  CatalogInternalFullMetaI,
  CatalogInternalFullTrackedI,
} from "./catalog-internal-full";
import {
  CatalogInternalFullTracked,
  CatalogInternalFullMeta,
} from "./catalog-internal-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogItemDTO,
  CatalogItemDTOOptional,
  CatalogItemDTOMetaI,
  CatalogItemDTOTrackedI,
} from "./catalog-item-dto";
import { CatalogItemDTOTracked, CatalogItemDTOMeta } from "./catalog-item-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogProductDTO,
  CatalogProductDTOOptional,
  CatalogProductDTOMetaI,
  CatalogProductDTOTrackedI,
} from "./catalog-product-dto";
import {
  CatalogProductDTOTracked,
  CatalogProductDTOMeta,
} from "./catalog-product-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogSharedDTO,
  CatalogSharedDTOOptional,
  CatalogSharedDTOMetaI,
  CatalogSharedDTOTrackedI,
} from "./catalog-shared-dto";
import {
  CatalogSharedDTOTracked,
  CatalogSharedDTOMeta,
} from "./catalog-shared-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogTaxDTO,
  CatalogTaxDTOOptional,
  CatalogTaxDTOMetaI,
  CatalogTaxDTOTrackedI,
} from "./catalog-tax-dto";
import { CatalogTaxDTOTracked, CatalogTaxDTOMeta } from "./catalog-tax-dto";

/**
 *
 * @export
 * @interface CatalogDTO
 */
export interface CatalogDTOOptional extends CatalogInternalFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogDTO
   */
  endActive?: Date;
  /**
   *
   * @type {number}
   * @memberof CatalogDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogDTO
   */
  catalogName?: string;
  /**
   *
   * @type {Array<CatalogCategoryDTO>}
   * @memberof CatalogDTO
   */
  categories?: CatalogCategoryDTOOptional[];
  /**
   *
   * @type {Array<CatalogItemDTO>}
   * @memberof CatalogDTO
   */
  items?: CatalogItemDTOOptional[];
  /**
   *
   * @type {Array<CatalogDiscountDTO>}
   * @memberof CatalogDTO
   */
  discounts?: CatalogDiscountDTOOptional[];
  /**
   *
   * @type {Array<CatalogTaxDTO>}
   * @memberof CatalogDTO
   */
  taxes?: CatalogTaxDTOOptional[];
  /**
   *
   * @type {Array<AgreementDTO>}
   * @memberof CatalogDTO
   */
  agreements?: AgreementDTOOptional[];
  /**
   *
   * @type {Array<CatalogProductDTO>}
   * @memberof CatalogDTO
   */
  products?: CatalogProductDTOOptional[];
}

export interface CatalogDTO
  extends CatalogDTOOptional, CatalogInternalFull, CatalogSharedDTO {
  /**
   *
   * @type {boolean}
   * @memberof CatalogDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogDTO
   */
  endActive?: Date;
  /**
   *
   * @type {number}
   * @memberof CatalogDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogDTO
   */
  catalogName?: string;
  /**
   *
   * @type {Array<CatalogCategoryDTO>}
   * @memberof CatalogDTO
   */
  categories?: CatalogCategoryDTO[];
  /**
   *
   * @type {Array<CatalogItemDTO>}
   * @memberof CatalogDTO
   */
  items?: CatalogItemDTO[];
  /**
   *
   * @type {Array<CatalogDiscountDTO>}
   * @memberof CatalogDTO
   */
  discounts?: CatalogDiscountDTO[];
  /**
   *
   * @type {Array<CatalogTaxDTO>}
   * @memberof CatalogDTO
   */
  taxes?: CatalogTaxDTO[];
  /**
   *
   * @type {Array<AgreementDTO>}
   * @memberof CatalogDTO
   */
  agreements?: AgreementDTO[];
  /**
   *
   * @type {Array<CatalogProductDTO>}
   * @memberof CatalogDTO
   */
  products?: CatalogProductDTO[];
}

export interface CatalogDTOTrackedI extends CatalogInternalFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDTO
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDTO
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDTO
   */
  catalogName?: string;
  catalogNameIsSet: boolean;
  /**
   *
   * @type {Array<CatalogCategoryDTO>}
   * @memberof CatalogDTO
   */
  categories?: CatalogCategoryDTOTrackedI[];
  categoriesIsSet: boolean;
  /**
   *
   * @type {Array<CatalogItemDTO>}
   * @memberof CatalogDTO
   */
  items?: CatalogItemDTOTrackedI[];
  itemsIsSet: boolean;
  /**
   *
   * @type {Array<CatalogDiscountDTO>}
   * @memberof CatalogDTO
   */
  discounts?: CatalogDiscountDTOTrackedI[];
  discountsIsSet: boolean;
  /**
   *
   * @type {Array<CatalogTaxDTO>}
   * @memberof CatalogDTO
   */
  taxes?: CatalogTaxDTOTrackedI[];
  taxesIsSet: boolean;
  /**
   *
   * @type {Array<AgreementDTO>}
   * @memberof CatalogDTO
   */
  agreements?: AgreementDTOTrackedI[];
  agreementsIsSet: boolean;
  /**
   *
   * @type {Array<CatalogProductDTO>}
   * @memberof CatalogDTO
   */
  products?: CatalogProductDTOTrackedI[];
  productsIsSet: boolean;
}

transformDatesMap.set("CatalogDTO", function (model: CatalogDTO) {
  if (typeof model.startActive == "string")
    model.startActive = new Date(model.startActive);
  if (typeof model.endActive == "string")
    model.endActive = new Date(model.endActive);
  const transformDatescategories = transformDatesMap.get("CatalogCategoryDTO");
  if (transformDatescategories) {
    model.categories?.forEach((sub) => {
      transformDatescategories(sub);
    });
  }
  const transformDatesitems = transformDatesMap.get("CatalogItemDTO");
  if (transformDatesitems) {
    model.items?.forEach((sub) => {
      transformDatesitems(sub);
    });
  }
  const transformDatesdiscounts = transformDatesMap.get("CatalogDiscountDTO");
  if (transformDatesdiscounts) {
    model.discounts?.forEach((sub) => {
      transformDatesdiscounts(sub);
    });
  }
  const transformDatestaxes = transformDatesMap.get("CatalogTaxDTO");
  if (transformDatestaxes) {
    model.taxes?.forEach((sub) => {
      transformDatestaxes(sub);
    });
  }
  const transformDatesagreements = transformDatesMap.get("AgreementDTO");
  if (transformDatesagreements) {
    model.agreements?.forEach((sub) => {
      transformDatesagreements(sub);
    });
  }
  const transformDatesproducts = transformDatesMap.get("CatalogProductDTO");
  if (transformDatesproducts) {
    model.products?.forEach((sub) => {
      transformDatesproducts(sub);
    });
  }
});

export type CatalogDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  catalogName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  categories: PropertyMeta<CatalogCategoryDTOMetaI>;
  //isDate: false
  //isDatetime: false
  items: PropertyMeta<CatalogItemDTOMetaI>;
  //isDate: false
  //isDatetime: false
  discounts: PropertyMeta<CatalogDiscountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  taxes: PropertyMeta<CatalogTaxDTOMetaI>;
  //isDate: false
  //isDatetime: false
  agreements: PropertyMeta<AgreementDTOMetaI>;
  //isDate: false
  //isDatetime: false
  products: PropertyMeta<CatalogProductDTOMetaI>;
}>;

export var CatalogDTOMeta: CatalogDTOMetaI = {} as CatalogDTOMetaI;
CatalogDTOMeta = typeMeta("CatalogDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  catalogName: propertyMeta(
    "catalogName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  categories: propertyMeta(
    "categories",
    true,
    false,
    false,
    CatalogCategoryDTOMeta,
  ),
  items: propertyMeta("items", true, false, false, CatalogItemDTOMeta),
  discounts: propertyMeta(
    "discounts",
    true,
    false,
    false,
    CatalogDiscountDTOMeta,
  ),
  taxes: propertyMeta("taxes", true, false, false, CatalogTaxDTOMeta),
  agreements: propertyMeta("agreements", true, false, false, AgreementDTOMeta),
  products: propertyMeta("products", true, false, false, CatalogProductDTOMeta),
});

const metaI = CatalogDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([CatalogInternalFullMeta]);
  metaI.isDeleted.inheritedFrom = CatalogInternalFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = CatalogInternalFullMeta.isNew;
  metaI.startActive.inheritedFrom = CatalogInternalFullMeta.startActive;
  metaI.endActive.inheritedFrom = CatalogInternalFullMeta.endActive;
  metaI.assignId.inheritedFrom = CatalogInternalFullMeta.assignId;
  metaI.catalogName.inheritedFrom = CatalogInternalFullMeta.catalogName;
  metaI.categories.inheritedFrom = CatalogInternalFullMeta.categories;
  metaI.items.inheritedFrom = CatalogInternalFullMeta.items;
  metaI.discounts.inheritedFrom = CatalogInternalFullMeta.discounts;
  metaI.taxes.inheritedFrom = CatalogInternalFullMeta.taxes;
  metaI.agreements.inheritedFrom = CatalogInternalFullMeta.agreements;
  metaI.products.inheritedFrom = CatalogInternalFullMeta.products;
  metaI.interfaces = metaI.interfaces.concat([CatalogSharedDTOMeta]);
  metaI.isDeleted.inheritedFrom = CatalogSharedDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = CatalogSharedDTOMeta.isNew;
  metaI.startActive.inheritedFrom = CatalogSharedDTOMeta.startActive;
  metaI.endActive.inheritedFrom = CatalogSharedDTOMeta.endActive;
  metaI.assignId.inheritedFrom = CatalogSharedDTOMeta.assignId;
  metaI.catalogName.inheritedFrom = CatalogSharedDTOMeta.catalogName;
  metaI.categories.inheritedFrom = CatalogSharedDTOMeta.categories;
  metaI.items.inheritedFrom = CatalogSharedDTOMeta.items;
  metaI.discounts.inheritedFrom = CatalogSharedDTOMeta.discounts;
  metaI.taxes.inheritedFrom = CatalogSharedDTOMeta.taxes;
  metaI.agreements.inheritedFrom = CatalogSharedDTOMeta.agreements;
});

export class CatalogDTOTracked
  extends CatalogInternalFullTracked
  implements CatalogDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  catalogName__I?: string = undefined;
  catalogNameIsSet: boolean = false;
  set catalogName(v: undefined | string) {
    if (v !== undefined) {
      this.catalogName__I = v;
      this.catalogNameIsSet = true;
    } else {
      this.catalogName__I = v || undefined;
      this.catalogNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get catalogName() {
    return this.catalogName__I;
  }
  categories__I?: CatalogCategoryDTOTracked[] = undefined;
  categoriesIsSet: boolean = false;
  set categories(v: undefined | CatalogCategoryDTOTracked[]) {
    if (v !== undefined) {
      this.categories__I = v;
      this.categoriesIsSet = true;
    } else {
      this.categories__I = v || undefined;
      this.categoriesIsSet = false;
    }
    this.changeTracker = true;
  }
  get categories() {
    return this.categories__I;
  }
  items__I?: CatalogItemDTOTracked[] = undefined;
  itemsIsSet: boolean = false;
  set items(v: undefined | CatalogItemDTOTracked[]) {
    if (v !== undefined) {
      this.items__I = v;
      this.itemsIsSet = true;
    } else {
      this.items__I = v || undefined;
      this.itemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get items() {
    return this.items__I;
  }
  discounts__I?: CatalogDiscountDTOTracked[] = undefined;
  discountsIsSet: boolean = false;
  set discounts(v: undefined | CatalogDiscountDTOTracked[]) {
    if (v !== undefined) {
      this.discounts__I = v;
      this.discountsIsSet = true;
    } else {
      this.discounts__I = v || undefined;
      this.discountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get discounts() {
    return this.discounts__I;
  }
  taxes__I?: CatalogTaxDTOTracked[] = undefined;
  taxesIsSet: boolean = false;
  set taxes(v: undefined | CatalogTaxDTOTracked[]) {
    if (v !== undefined) {
      this.taxes__I = v;
      this.taxesIsSet = true;
    } else {
      this.taxes__I = v || undefined;
      this.taxesIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxes() {
    return this.taxes__I;
  }
  agreements__I?: AgreementDTOTracked[] = undefined;
  agreementsIsSet: boolean = false;
  set agreements(v: undefined | AgreementDTOTracked[]) {
    if (v !== undefined) {
      this.agreements__I = v;
      this.agreementsIsSet = true;
    } else {
      this.agreements__I = v || undefined;
      this.agreementsIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreements() {
    return this.agreements__I;
  }
  products__I?: CatalogProductDTOTracked[] = undefined;
  productsIsSet: boolean = false;
  set products(v: undefined | CatalogProductDTOTracked[]) {
    if (v !== undefined) {
      this.products__I = v;
      this.productsIsSet = true;
    } else {
      this.products__I = v || undefined;
      this.productsIsSet = false;
    }
    this.changeTracker = true;
  }
  get products() {
    return this.products__I;
  }
  constructor(config?: CatalogDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.categories?.forEach((a) => a.setIds());

    this.items?.forEach((a) => a.setIds());

    this.discounts?.forEach((a) => a.setIds());

    this.taxes?.forEach((a) => a.setIds());

    this.agreements?.forEach((a) => a.setIds());

    this.products?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: CatalogDTOOptional,
    options?: AssignOptions,
  ): CatalogDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.catalogName &&
      this.catalogNameApplyFilter(optionsRequired.filter)
    ) {
      this.catalogName = config.catalogName;
      if (optionsRequired.unassign) this.catalogNameIsSet = false;
      else this.catalogNameIsSet = true;
    }
    if (
      config.categories &&
      this.categoriesApplyFilter(optionsRequired.filter)
    ) {
      this.categories = config.categories?.map(
        (a) => new CatalogCategoryDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.categoriesIsSet = false;
      else this.categoriesIsSet = true;
    }
    if (config.items && this.itemsApplyFilter(optionsRequired.filter)) {
      this.items = config.items?.map(
        (a) => new CatalogItemDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.itemsIsSet = false;
      else this.itemsIsSet = true;
    }
    if (config.discounts && this.discountsApplyFilter(optionsRequired.filter)) {
      this.discounts = config.discounts?.map(
        (a) => new CatalogDiscountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.discountsIsSet = false;
      else this.discountsIsSet = true;
    }
    if (config.taxes && this.taxesApplyFilter(optionsRequired.filter)) {
      this.taxes = config.taxes?.map(
        (a) => new CatalogTaxDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.taxesIsSet = false;
      else this.taxesIsSet = true;
    }
    if (
      config.agreements &&
      this.agreementsApplyFilter(optionsRequired.filter)
    ) {
      this.agreements = config.agreements?.map(
        (a) => new AgreementDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.agreementsIsSet = false;
      else this.agreementsIsSet = true;
    }
    if (config.products && this.productsApplyFilter(optionsRequired.filter)) {
      this.products = config.products?.map(
        (a) => new CatalogProductDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.productsIsSet = false;
      else this.productsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogDTOTrackedI {
    const cloned = {} as CatalogDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.catalogNameIsSetDeep() &&
      this.catalogNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.catalogNameIsSet = true;
      cloned.catalogName = this.catalogName;
    } else {
      //cloned.catalogNameIsSet = false
    }
    if (
      this.categoriesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.categoriesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoriesIsSet = true;
      cloned.categories = this.categories
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.categoriesIsSet = false
    }
    if (
      this.itemsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.itemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemsIsSet = true;
      cloned.items = this.items
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.itemsIsSet = false
    }
    if (
      this.discountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.discountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountsIsSet = true;
      cloned.discounts = this.discounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.discountsIsSet = false
    }
    if (
      this.taxesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.taxesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxesIsSet = true;
      cloned.taxes = this.taxes
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.taxesIsSet = false
    }
    if (
      this.agreementsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.agreementsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementsIsSet = true;
      cloned.agreements = this.agreements
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.agreementsIsSet = false
    }
    if (
      this.productsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.productsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.productsIsSet = true;
      cloned.products = this.products
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.productsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.catalogNameApplyFilter(filter)) this.catalogNameIsSet = false;

    if (!this.categoriesApplyFilter(filter)) this.categoriesIsSet = false;

    this.categories?.forEach((a) => a.unassignAll(filter));
    if (!this.itemsApplyFilter(filter)) this.itemsIsSet = false;

    this.items?.forEach((a) => a.unassignAll(filter));
    if (!this.discountsApplyFilter(filter)) this.discountsIsSet = false;

    this.discounts?.forEach((a) => a.unassignAll(filter));
    if (!this.taxesApplyFilter(filter)) this.taxesIsSet = false;

    this.taxes?.forEach((a) => a.unassignAll(filter));
    if (!this.agreementsApplyFilter(filter)) this.agreementsIsSet = false;

    this.agreements?.forEach((a) => a.unassignAll(filter));
    if (!this.productsApplyFilter(filter)) this.productsIsSet = false;

    this.products?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDTOMeta.isDeleted,
      CatalogDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CatalogDTOMeta.isNew, CatalogDTOMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDTOMeta.startActive,
      CatalogDTOMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDTOMeta.endActive,
      CatalogDTOMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CatalogDTOMeta.assignId, CatalogDTOMeta, this.assignId, this);
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  catalogNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDTOMeta.catalogName,
      CatalogDTOMeta,
      this.catalogName,
      this,
    );
  }
  catalogNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.catalogNameIsSet && this.catalogNameApplyFilter(filter))
      return true;

    return false;
  }
  categoriesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDTOMeta.categories,
      CatalogDTOMeta,
      this.categories,
      this,
    );
  }
  categoriesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoriesIsSet && this.categoriesApplyFilter(filter)) return true;

    return this.categories?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  itemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CatalogDTOMeta.items, CatalogDTOMeta, this.items, this);
  }
  itemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemsIsSet && this.itemsApplyFilter(filter)) return true;

    return this.items?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  discountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDTOMeta.discounts,
      CatalogDTOMeta,
      this.discounts,
      this,
    );
  }
  discountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountsIsSet && this.discountsApplyFilter(filter)) return true;

    return this.discounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  taxesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CatalogDTOMeta.taxes, CatalogDTOMeta, this.taxes, this);
  }
  taxesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxesIsSet && this.taxesApplyFilter(filter)) return true;

    return this.taxes?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  agreementsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDTOMeta.agreements,
      CatalogDTOMeta,
      this.agreements,
      this,
    );
  }
  agreementsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementsIsSet && this.agreementsApplyFilter(filter)) return true;

    return this.agreements?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  productsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CatalogDTOMeta.products, CatalogDTOMeta, this.products, this);
  }
  productsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.productsIsSet && this.productsApplyFilter(filter)) return true;

    return this.products?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.catalogNameIsSetDeep(filter)) return true;
    if (this.categoriesIsSetDeep(filter)) return true;
    if (this.itemsIsSetDeep(filter)) return true;
    if (this.discountsIsSetDeep(filter)) return true;
    if (this.taxesIsSetDeep(filter)) return true;
    if (this.agreementsIsSetDeep(filter)) return true;
    if (this.productsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
